export default "__VITE_ASSET__Xvo7jEKs__"